import { useEffect } from 'preact/hooks'
import { PageHeader } from '@/components/common/PageHeader'
import { usePageHeader } from '@/hooks/usePageHeader'
import { useWorkspaceCapabilities } from '@/hooks/useWorkspaceCapabilities'
import { routes } from '@/utils/routes'
import { BrandGuidelinesView } from './BrandGuidelinesView'

/** The company's own Brand Guidelines, in Admin settings: the one place they change (ORB-904). */
export function CompanyBrandGuidelinesPage({ clientCompanyId }: { clientCompanyId: string }) {
  return (
    <div className="p-6 flex flex-col gap-4">
      <PageHeader items={[{ text: 'Knowledge Base', href: routes.settingsKnowledgeBase(clientCompanyId) }, { text: 'Brand Guidelines' }]} />
      <BrandGuidelinesView scope={{ clientCompanyId }} canChange />
    </div>
  )
}

interface ScopedProps {
  clientCompanyId: string
  workspaceId: string
  campaignId?: string
}

/**
 * What a workspace, or one of its campaigns, builds with (ORB-904). A workspace's editors change the workspace's own
 * brand here, which it gets on its first change (ORB-1027); a campaign takes its workspace's, read only. The breadcrumb
 * leads back to the knowledge base the page was opened from.
 */
export function ScopedBrandGuidelinesPage({ clientCompanyId, workspaceId, campaignId }: ScopedProps) {
  const { setHeader } = usePageHeader()
  const { canEdit } = useWorkspaceCapabilities(clientCompanyId, workspaceId)
  const scoped = routes.scoped(clientCompanyId, workspaceId)
  const back = campaignId ? scoped.campaign(campaignId, { tab: 'knowledge-base' }) : scoped.knowledgeBase()

  useEffect(() => {
    setHeader({ items: [{ text: 'Knowledge Base', href: back }, { text: 'Brand Guidelines' }] })
  }, [back])

  return (
    <div className="p-6">
      <BrandGuidelinesView scope={{ clientCompanyId, workspaceId, campaignId }} canChange={!campaignId && canEdit} />
    </div>
  )
}
